<template>
  <button
    type="button"
    aria-label="Search"
    class="inline-flex h-8 shrink-0 items-center gap-2 rounded-full border border-fp-green-7 bg-[#173126] p-2 text-fp-green-0/55 hover:border-fp-green-3/50 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-fp-green-3/30"
    @click="emit('open')"
  >
    <MagnifyingGlassIcon
      class="size-4 shrink-0 text-fp-green-1"
      aria-hidden="true"
    />
    <span class="text-xs font-medium whitespace-nowrap">{{
      searchHotkeyLabel
    }}</span>
  </button>
</template>

<script lang="ts" setup>
import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline'
import { computed } from 'vue'

const emit = defineEmits<{
  (event: 'open'): void
}>()

const searchHotkeyLabel = computed(() => {
  if (typeof navigator === 'undefined') return '⌘K'
  const platform = navigator.platform || navigator.userAgent
  return /Mac|iPhone|iPad|iPod/i.test(platform) ? '⌘K' : 'Ctrl+K'
})
</script>
